import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const countryImporterSelectors = importerSelectors(
  'country.importer',
);

export default countryImporterSelectors;
